export default __webpack_public_path__ + "static/media/section-5-2ndicon.35bdb20c.png";